module.exports = __webpack_public_path__ + "static/img/15.ec7d1ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/15.png
// module id = CIhx
// module chunks = 0